// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Timestamp$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";

function getTableColumnsSchema(workspace_dispatch, msisdn) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Start Date"
            },
            accessor: (function (incentive) {
                return {
                        TAG: /* Text */0,
                        _0: Timestamp$Catalyst.toString(incentive.start_date, "DD MMM YYYY")
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "End Date"
              },
              accessor: (function (incentive) {
                  return {
                          TAG: /* Text */0,
                          _0: Timestamp$Catalyst.toString(incentive.end_date, "DD MMM YYYY")
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Campaign ID"
                },
                accessor: (function (incentive) {
                    return {
                            TAG: /* Custom */5,
                            _0: (function (param) {
                                return React.createElement(PrimaryButton$Catalyst.make, {
                                            buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                                  TAG: /* Text */0,
                                                  _0: incentive.campaign_id
                                                }, undefined, (function (param) {
                                                    return Curry._2(workspace_dispatch.addTab, {
                                                                TAG: /* CampaignOrders */46,
                                                                _0: incentive.campaign_id,
                                                                _1: msisdn
                                                              }, false);
                                                  }), undefined, undefined, undefined, undefined, undefined, undefined, undefined)
                                          });
                              })
                          };
                  })
              },
              tl: {
                hd: {
                  column: {
                    TAG: /* Text */0,
                    _0: "Incentive Parameters"
                  },
                  accessor: (function (incentive) {
                      return {
                              TAG: /* Text */0,
                              _0: "Completed trips: " + String(incentive.completed_trips) + " | ABRTG allowed: " + String(incentive.abrtg_allowed) + " | Missed order allowed: " + String(incentive.missed_order_allowed) + " | Fraud allowed: " + String(incentive.fraud_allowed)
                            };
                    })
                },
                tl: /* [] */0
              }
            }
          }
        };
}

function DriverIncentiveListTable(Props) {
  var tableData = Props.tableData;
  var workspace_dispatch = Props.workspace_dispatch;
  var msisdn = Props.msisdn;
  return React.createElement("div", {
              className: "table-wrapper"
            }, React.createElement(TableComponent$Catalyst.make, {
                  columns: getTableColumnsSchema(workspace_dispatch, msisdn),
                  rowData: tableData,
                  className: "customTable"
                }));
}

var make = DriverIncentiveListTable;

export {
  getTableColumnsSchema ,
  make ,
  
}
/* react Not a pure module */
